import React from 'react';
import { ArrowDownRightIcon, ArrowUpRightIcon, MinusIcon } from 'lucide-react';
interface DeltaChipProps {
  /** Signed change; only its sign is used for direction and tone */
  value: number;
  text: string;
  /** When true, a decrease is good (e.g. wrap-up time) */
  invert?: boolean;
  className?: string;
}
export function DeltaChip({
  value,
  text,
  invert = false,
  className = ''
}: DeltaChipProps) {
  const neutral = Math.abs(value) < 1e-9;
  const good = invert ? value < 0 : value > 0;
  const Icon = neutral ? MinusIcon : value > 0 ? ArrowUpRightIcon : ArrowDownRightIcon;
  const tone = neutral ? 'text-muted' : good ? 'text-positive' : 'text-danger';
  return <span className={`inline-flex items-center gap-0.5 whitespace-nowrap text-xs font-semibold ${tone} ${className}`} data-id="element-102" data-mp="38crpv23xx754">
      <Icon className="h-3.5 w-3.5" aria-hidden data-id="element-103" data-mp="1hzsk0gbprzyk" />
      <span className="sr-only" data-id="element-104" data-mp="1i0lr5iel4rh8">{neutral ? 'No change' : value > 0 ? 'Up' : 'Down'}</span>
      {text}
    </span>;
}